<template>
  <v-container fluid>
    <v-card flat>
      <v-container fluid>
          <h1 class="earth-color text-md-center">MEMBERSHIP DETAILS</h1>
          
          <div class="row container" style="color: gray">
            {{selectedSetting.membership_type}} {{selectedSetting.residence}} {{selectedSetting.name}} - {{localCurrency}} {{convert1('Kes', selectedSetting.price).amount}}
          </div>
          <hr>
          <div class="row container" style="color: gray">
            <h3 class="earth-color">Admits:</h3>
            <br>
            {{selectedSetting.number_of_persons}} adult(s)
            <br>
            {{selectedSetting.number_of_children}} children
          </div>
          <hr>
          <v-container class="row container">
            <h3 class="earth-color">BENEFICIARIES:</h3>
            <br>
           <v-layout row wrap v-for="(beneficiary, key) in allBeneficiaries" :key="key" mb-4>
             <v-flex lg8 md8 sm12 xs12>
               <b>Name : </b> {{beneficiary.title}} {{beneficiary.first_name}} {{beneficiary.sur_name}}<br>
               <b>Email : </b> {{beneficiary.email}}<br>
               <b>Phone Number : </b> {{beneficiary.phone_number}}<br>
               <b>Date of Birth : </b> {{beneficiary.dob}}<br>
               <b>ID : </b> {{beneficiary.id_alien_number}}
             </v-flex>
             <v-flex lg4 md4 sm12 xs12>
               <v-btn :depressed="true" small round color="error" @click="removeBeneficiary(beneficiary)">X</v-btn>
             </v-flex>
           </v-layout>
          <hr>
          <v-container>
              <h3 class="earth">TOTAL: {{localCurrency}} {{$roundOff(memberTotal)}}</h3>
          </v-container>
          </v-container>
        </v-container>
      </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'membership-cart',
  data () {
    return {
    }
  },
  computed: {
    localCurrency: function () {
      return this.$store.state.CurrencyStore.browser_currency
    }
  },
  methods: {
    removeBeneficiary: function (beneficiary) {
      this.allBeneficiaries.pop(beneficiary)
    }
  }
}
</script>

<style scoped>

</style>
